import { render } from "./CaseSquarePage.vue?vue&type=template&id=6e67a864&scoped=true"
import script from "./CaseSquarePage.vue?vue&type=script&lang=js"
export * from "./CaseSquarePage.vue?vue&type=script&lang=js"

import "./CaseSquarePage.vue?vue&type=style&index=0&id=6e67a864&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e67a864"]])

export default __exports__